import { createBreakpoints } from '@mui/system';

export const breakpoints = {
  values: {
    xs: 0,
    sm: 375,
    md: 768,
    lg: 1280,
    xl: 1440
  }
};

export const themeBreakpoints = createBreakpoints(breakpoints);
